import { render, staticRenderFns } from "./SearchPlaceholder.vue?vue&type=template&id=0af6bbcc&"
import script from "./SearchPlaceholder.vue?vue&type=script&lang=ts&"
export * from "./SearchPlaceholder.vue?vue&type=script&lang=ts&"
import style0 from "./SearchPlaceholder.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports